
// 第一层：冻结对象原型，禁止修改constructor/prototype，从底层堵死污染
Object.freeze(Object.prototype);
Object.freeze(Object);

// 第二层：重写全局 _.defaultsDeep，过滤所有污染关键字
let _;
// 延迟覆盖lodash高危方法
window.addEventListener('load', () => {
  _ = window._;
  const originDeep = _.defaultsDeep;
  // 递归过滤危险key
  const safeParse = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    const target = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
      if(['__proto__','constructor','prototype'].includes(key)) continue;
      target[key] = safeParse(obj[key]);
    }
    return target;
  };
  _.defaultsDeep = function(target, ...sources){
    const newSources = sources.map(s => safeParse(s));
    return originDeep(target, ...newSources);
  }
})
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import router from './router'
import VueCookies from 'vue-cookies'
import 'es6-promise/auto'
import "jquery"

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'  // 注意样式文件需要单独引入

import './assets/css/stylenew.css'
import './assets/css/user.css'
import './assets/css/style.css'
import './assets/css/reg_user.css'
import './assets/bootstrap-3.3.2-dist/css/bootstrap.min.css'
import './assets/css/resume.css'//简历
import './assets/css/step.css'

import './assets/font/iconfont.css'
import './assets/font1/iconfont.css'
import './assets/font2/iconfont.css'
import './assets/font/new_font/iconfont.css'

import api from './api/index'
import commons from '@/utils/commons.js'
import file from '@/api/file.js'
import config from '@/config'
import util from '@/utils/util.js'
import modal from "@/plugins/modal"

import singleCourse from '@/components/singleCourse.vue'
//打印
import Print from 'vue-print-nb'
// 通用下载方法
// import { download } from '@/utils/request'


let layer;
window.layui.use("layer", () => {
  layer = window.layui.layer;
  Vue.prototype.$layer = layer;
  Vue.prototype.$layerMsg = {
    success: (msg) => {
      layer.msg(msg, { time: 3000, icon: 1 });
    },
    error: (msg) => {
      layer.msg(msg, { time: 3000, icon: 2 });
    },
    warn: (msg) => {
      layer.msg(msg, { time: 3000, icon: 0 });
    },
    info: (msg) => {
      layer.msg(msg, { time: 3000 });
    }
  }
});

// 注册组件
Vue.component('single-course', singleCourse)

// 调用插件
Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(Print)

Vue.config.productionTip = false

Vue.prototype.$commons = commons;
Vue.prototype.$config = config;
Vue.prototype.$util = util;
Vue.prototype.$api = api;
Vue.prototype.$layui = window.layui;
Vue.prototype.TcPlayer = window.TCPlayer;
Vue.prototype.$modal = modal
// Vue.prototype.$download = download
Vue.prototype.$file = file;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios: VueAxios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js